import * as React from "react"
import { keyframes } from "@emotion/react"
import { Box, Skeleton, useTheme } from "@mui/material"
import { ButtonIconSeeker } from "@ui-seeker/core"
import { AppTableSeeker } from "@components"

import { endDateColumn, firstDateColumn, productIDColumn, productURLColumn, retailerInfoColumn, skipColumn, validatedColumn } from "./columns"
import { useAdminSkuViewMapping } from "../@hooks"
import {adminSkuRowViewedMappings} from "../@signals";
import {isEmpty} from "@ui-seeker/utils";


export default function AdminSkuMappingTable() {
    const { palette } = useTheme()
    const { isLoading, data, skuName, handleClose } = useAdminSkuViewMapping()

    if (isLoading)
        return <Skeleton variant="rectangular" height={700} />
    if (!data.length)
        return <></>

    return <Box id="product-mapping">
        <AppTableSeeker
            title={`Mappings for ${skuName}`}
            data={data}
            columns={[
                endDateColumn(),
                firstDateColumn(),
                ...retailerInfoColumn(),
                ...productIDColumn(),
                productURLColumn(),
                ...validatedColumn(),
                // ...skipColumn()  // DISABLED TEMPORARILY
            ]}
            options={{
                customToolbar: () => <ButtonIconSeeker icon="xmark" onClick={handleClose} />,
                enhancedSetRowProps: () => ({ sx: {
                    "&:has(.is-loading)": {
                        animation: `${keyframes({
                            "0%": { backgroundColor: palette.info.light },
                            "100%": { backgroundColor: palette.info.lighter }
                        })} 1s linear infinite alternate`
                    },
                    "&:has(.is-clicked)": {backgroundColor: "warning.light"}
                } })
            }}
        />
    </Box>
}